import React from "react";
import AppConfirmationPrompt from "../Components/AppConfirmationPrompt";

interface Props {
  onHide: () => void;
  show: boolean;
  setConfirm: (isConfirm: boolean) => void;
  confirmButtonText?: string;
  title?: string;
  body?: React.ReactNode;
  cancelButtonText?: string;
}

const ConfirmationModal: React.FC<Props> = ({
  onHide,
  show,
  setConfirm,
  confirmButtonText,
  title = "Please confirm",
  body = "Are you sure you want to proceed?",
  cancelButtonText = "Cancel",
}) => {
  return (
    <AppConfirmationPrompt
      show={show}
      title={title}
      body={body}
      confirmText={confirmButtonText || "Confirm"}
      cancelText={cancelButtonText}
      onClose={onHide}
      onConfirm={() => setConfirm(true)}
      onCancel={() => setConfirm(false)}
    />
  );
};

export default ConfirmationModal;
